<template>
    <div class="Blog">
        <Menu :sesion="sesion" :url="url" v-if="sesion"/>
        <Submenu :menuActivo="4" :url="url"/>

        <div class="container-fluid pt-3">
            <div class="row">
                <div class="col-sm-4">
                    <nav>
                        <div class="nav nav-tabs text-center row py-3 px-3" id="nav-tab" role="tablist">
                            <a class="nav-link active col-sm-4" id="nav-profile-tab" data-toggle="tab" 
                                href="#navActi" 
                                role="tab" 
                                aria-controls="nav-profile" 
                                aria-selected="false" 
                                @click="getChats()">Chats</a>

                            <a class="nav-link col-sm-4" id="nav-contact-tab" 
                               data-toggle="tab" 
                               href="#navArchivados" 
                               role="tab" 
                               aria-controls="nav-contact" 
                               aria-selected="false"
                               @click="getChatArchivados()" >Archivados</a>
                        </div>
                    </nav>

                    <div class="tab-content" id="nav-tabContent">

                        <!--Spinner-->
                        <div class="d-flex justify-content-center mt-5" v-if="!status">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>

                        <!--Chats buttons-->
                        <div v-else>
                            <div v-if="bandera_chats == 1" class="tab-pane fade show active" id="navActi" role="tabpanel" aria-labelledby="nav-home-tab">
                            <div class="conversaciones row" v-for="f in chats" :key="f.id">
                                <div class="col-sm-12">
                                    <!--Info chat-->
                                    <div class="row info-conv" :class="{'activeChat' : f.idProyecto == id_proyecto && f.usuario == usuario}">
                                        <div class="col-sm-3">
                                            <img :src="getUrl(f.avatar)" class="img" alt="Img">
                                        </div>
                                        <div class="col-sm-7" :class="[{'sinLeer' : f.vistoEmpresa == 0 && rol == 1},{'sinLeer' : f.vistoConsultor == 0 && rol == 0}]"
                                             @click="catchIds(f, true)">
                                            <small><b>@{{f.usuario}}</b></small><br>
                                            <small>Proyecto: {{f.titulo_proyecto}}
                                                <span class="badge badge-danger">1</span>
                                            </small>
                                        </div>
                                        <!--boton submenu-->
                                        <div class="submenu col-sm-2">
                                            <button class="btn btn-light" type="button" id="dropdownMenuButton" data-toggle="dropdown" 
                                            aria-haspopup="true" aria-expanded="false">
                                                <font-icon icon="ellipsis-v"></font-icon>
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                <a class="dropdown-item" @click="archivar(f)">Archivar</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="chats == null">
                                <h4 class="text-center mt-5">Aun no tienes conversaciones</h4>
                            </div>

                             </div>
                        </div>


                        <!--Chats buttons archivados-->
                        <div v-if="bandera_chats == 2" class="tab-pane fade show" id="navArchivados" role="tabpanel" aria-labelledby="nav-contact-tab">
                            
                            <div class="tab-pane fade show active" id="navActi" role="tabpanel" aria-labelledby="nav-home-tab">

                                <div class="conversaciones row" v-for="f in chats" :key="f.id">
                                    <!--<button class="btn btn-light col-sm-10" -->
                                    <div class="col-sm-12" 
                                    @click="catchIds(f, true)">
                                        <!--Info chat-->
                                        <div class="row info-conv" :class="{'activeChat' : f.idProyecto == id_proyecto && f.usuario == usuario}">
                                            <div class="col-sm-3">
                                                <img :src="getUrl(f.avatar)" class="img" alt="Img">
                                            </div>
                                            <div class="col-sm-9">
                                                <small><b>@{{f.usuario}}</b></small><br>
                                                <small>Proyecto: {{f.titulo_proyecto}}</small>
                                            </div>
                                        </div>
                                    </div>
                                    <!--boton submenu
                                    <div class="submenu col-sm-2" v-if="!verificarArchivados(f.archivadoEmp, f.archivadoCons)">
                                        <button class="btn btn-light mt-3" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <font-icon icon="ellipsis-v"></font-icon>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <a class="dropdown-item" @click="archivar(f.id_reg)">Archivar</a>
                                        </div>
                                    </div> -->
                                </div>

                            </div>

                        </div>
                    </div>

                   
                </div>
                    
                <!--Form del chat -->
                <form style="background-color:white" class="chat col-sm-8" @submit="sendMsg" v-if="id_reg != 0">

                    <div class="container-fluid info-chat mb-1" v-if="id_reg != 0">
                        <div class="row">
                            <div class="col-sm-8"> 
                                <p class="mt-2 text-left">
                                    <img :src="img_avatar" class="img img-avatar rounded mr-3" alt="Img">
                                    <b>@{{usuario}}</b>
                                </p>
                            </div>
                            <div class="mt-2 col-sm-4">
                                <p class="text-right mt-2"> Proyecto:  
                                    <router-link class="mt-2 titulo-proyecto" :to="{ name: 'DetalleProyecto', params: { idEmpresa: id_proyecto}}"> 
                                        <b> {{titulo_proyecto}}</b>
                                    </router-link>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="card card-chat">
                        <div class="card-body body-chat">
                            <div class="row" v-if="rol == 1">
                                <div class="col-md-12" v-for="f in msg_user" :key="f.id">
                                    <p class="float-right burbuja" v-if="f.propietario == '1'">{{f.mensaje}}</p>

                                    <p class="float-left burbuja-white" v-if="f.propietario == '0'">{{f.mensaje}}</p>
                                </div>
                            </div>
                            <div class="row" v-else>
                                <div class="col-md-12" v-for="f in msg_user" :key="f.id">
                                    <p class="float-right burbuja" v-if="f.propietario == '0'">{{f.mensaje}}</p>
                                    <p class="float-left burbuja-white" v-if="f.propietario == '1'">{{f.mensaje}}</p>
                                </div>
                            </div>
                            
                        </div>
                    </div>

                    <!--<div class="row my-2" v-if="archivo1 != 1 && rol == 1 || archivo2 != 1 && rol == 0">-->
                    <div class="row my-2" v-if="archivo1 == 1 || archivo2 == 1">
                        <div class="col-sm-11">
                            <p class="text-center"><b>Este chat se ha concluido por alguna de las partes</b></p>
                        </div>
                    </div>
                    <div class="row pt-2 pb-4" v-else>
                        <div class="col-sm-11">
                            <input type="text" class="form-control" placeholder="Escriba un mensaje...." v-model="msg">
                        </div>
                        <div class="col-sm-1">
                            <button class="btn float-right orange">Enviar </button>
                        </div>
                    </div>
                </form>
                
                <h4 v-if="id_reg == 0" class="text-center mt-5 col-sm-8">No tiene ninguna conversacion seleccionada</h4>

            </div>
        </div>
        
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'
import Submenu from '@/components/Submenu'
import Menu from '@/components/Menu'

export default {
    mixins: [ globalFunctions ],
    name:'Blog',
    data(){
        return{
            sesion:false,
            id_reg: 0,
            msg: '',
            msg_user: [],
            chats: [],
            chatsL: [],
            MsgL: [],
            rol: localStorage.rol,
            no_leidos: 0,
            nombres: '',
            img_avatar: '',
            titulo_proyecto: '',
            id_proyecto: '',
            usuario: '',
            msgNoleido: 0,
            status: false,
            prop1: this.$route.query.tabla,
            prop2: this.$route.query.tabla2,
            archivo1: '',
            archivo2: '',
            bandera_chats: ''
        }
    },
    components:{
        Submenu,Menu
    },
    computed:{
    ...mapState(['url'])
    },
    mounted(){
        //check
        let resp = this.checkUser();
        this.sesion = resp;

        this.getChats();
        this.getChatsnoleidos();
    },
    created: function() {
		var self = this;
        
        setInterval(function() {
          self.getMensajes()}, 1000*60);

        var self2 = this;
        
        setInterval(function() {
          self2.getChatsnoleidos()}, 1000*60);
    },
    methods: {
        sendMsg(e){
            e.preventDefault();
            
            let data = {
                flag: 1,
                id_reg: this.id_reg,
                msg: this.msg,
                propietario: localStorage.rol
            }
            
            this.axios.post(this.url + 'altaChat.php', data).then((responce) =>{
                //console.log('responce data altaChat =>', responce.data);
                this.msg = '';
                this.getMensajes();
                this.getChats();
            })
        },

        getMensajes(){

            let data = {
                flag: 0,
                id: this.id_reg
            }

            this.axios.post(this.url + 'getChat.php', data).then((responce) =>{
                //console.log('responce data getMensajes =>', responce.data);
                this.msg_user = responce.data;
            })
        },

        getChatsAxios(data){

            this.axios.post(this.url + 'getChat.php', data).then((responce) =>{
                //console.log(responce.data);
                if(responce.status == 200){
                    this.status = true;
                    this.chats = responce.data;
                    //console.log(this.chats);
                    let long = this.chats.length;

                    if(this.$route.query.tabla != null){
                        this.$route.query.tabla = null;

                        for (let i = 0; i < long; i++) {
                            if (this.chats[i].id_user == this.prop1 && this.chats[i].idProyecto == this.prop2){
                               this.catchIds(this.chats[i],false );
                            }
                        }
                    }
                }
            });
        },

        getChats(){
            this.bandera_chats = 1;
            this.chats = 0;

            let data = {
                flag: 1,
                id: localStorage.userID,
                rol: localStorage.rol
            }

            this.getChatsAxios(data);
        },

        getChatArchivados(){
            this.$route.query.tabla = null
            this.bandera_chats = 2;
            this.chats = null;

            let data = {
                flag: 6,
                id: localStorage.userID,
                rol: localStorage.rol
            }

            this.getChatsAxios(data);
        },

        catchIds(f, band){
            //console.log(f);
            this.id_reg = f.id_reg;
            this.nombres = f.nombres + ' ' + f.apellidos;
            this.usuario = f.usuario;
            this.img_avatar = this.getUrl(f.avatar);
            this.titulo_proyecto = f.titulo_proyecto;
            this.id_proyecto = f.idProyecto;
            this.archivo1 = f.archivadoCons;
            this.archivo2 = f.archivadoEmp;

            if(band){
                if(this.rol == 1){
                    this.updateVisto(f.vistoEmpresa);
                    this.getMensajes();
                }
                else{
                    this.updateVisto(f.vistoConsultor);
                    this.getMensajes();
                }
            }else{
                this.getMensajes();
            }
        
        },

        updateVisto(visto){ //obtener chats no leidos
            let flag = false;

            if(visto != 1){
                flag = true;
            }

            let data = {
                flag: 3,
                id: this.id_reg,
                rol: localStorage.rol
            }
            
            if (flag == true){
                this.axios.post(this.url + 'altaChat.php', data).then((responce) =>{
                    if(responce.data == 200){
                        this.getChats();
                    }
                });
            }
            
        },

        archivar(f){
            //console.log(f);
            
            if(this.rol == 0){
                let user = localStorage.userID;
                
                if(f.asignadaA == user){
                    alert("No es posible archivar este chat hasta que el proyecto se concluya");
                    return;
                }
            }else{
                if(f.asignadaA == f.id_user){
                    alert("No es posible archivar este chat hasta que el proyecto se concluya");
                    return;
                }
            }

            this.$swal.fire({
                title: '¿Estas Seguro?',
                text: "Ya no podras tener conversaciones sobre este proyecto con este usuario",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, archivar conversacion'
                }).then((result) => {
                    if (result.isConfirmed) {
                                
                    let data = {
                        flag: 2,
                        id: f.id_reg,
                        rol: localStorage.rol
                    }

                    this.axios.post(this.url + 'altaChat.php', data).then((responce) =>{
                        if(responce.data == 200){
                            //location.reload();
                            this.$router.push('/Blog?tabla=' + '' + '&tabla2=' + '');
                            //this.getChats();
                            location.reload();
                        }
                    });
                }
            })
        },

        getChatsnoleidos(){

            let data = {
                flag: 3,
                id: localStorage.userID,
                rol: localStorage.rol
            }

            this.axios.post(this.url + 'getChat.php', data).then((responce) =>{
                //console.log('responce data getChatsnoleidos =>', responce.data);
                if(responce.data == null){
                    this.no_leidos = 0;
                    this.chatsL = [];
                }else{
                    this.chatsL = responce.data;
                    this.no_leidos = this.chatsL.length;
                }
            });
        },

        getMsgnoleidos(idr){
            let data = {
                flag: 4,
                id: localStorage.userID,
                rol: localStorage.rol,
                id2: idr
            }

            //console.log('data getMsgnoleidos', data);
            this.axios.post(this.url + 'getChat.php', data).then((responce) =>{
                //console.log('responce data getMsgnoleidos =>', responce.data[0].msg);
                this.MsgL = responce.data;
                return responce.data[0].msg;
            });
        },


    },
}
</script>

<style scoped>
.burbuja{
    /*background-color:  rgb(0, 76, 163);*/
    min-width: 0px;
    max-width: 250px;
    background-color: rgb(67, 133, 255);
    color: white;
    padding: 5px;
    border-radius: 15px;
    
}
.burbuja-white{
    /*background-color: rgb(252, 183, 56);*/
    min-width: 0px;
    max-width: 250px;
    background-color: rgb(86, 87, 88);
    color: white;
    padding: 5px;
    border-radius: 15px;
}
/*.body-chat{*/
.card-chat{
    /*height: 400px;
    overflow:scroll;
    overflow-x: auto;*/
    height: 400px;
    overflow: auto;
    margin: 0 auto;
}

.body-chat{
    height: 450px;
    direction: ltr;
}

.sinLeer small{
    /*background-color: rgb(238, 235, 235) !important;*/
    /*border:1px solid rgb(228, 223, 223) !important;*/
    font-weight: bold;
    color: black !important;
}

.sinLeer span{
    display: inline !important;
}

.conversaciones{
    border-radius: 5px;
    padding: 5px;
}

.conversaciones span{
    display: none;
}

.info-chat{
    background-color: #0e1724;
    color: #fff;
    cursor: pointer;
}

.info-conv{
    height: 100px;
    padding: 15px;
    margin-top: 15px;
    background-color: #fff;
    border-radius: 5px;
    cursor: pointer;
}
.buttons-conv{
    height: 300px;
    overflow: auto;
}
.submenu{
    position: relative;
    top: 15px;
}

.dropdown-item{
    cursor: pointer;
}

.wrapper{
    display: flex;
    align-items: center;
    flex-direction: column; 
    justify-content: center;
    width: 100%;
    background-color: transparent;
    margin: 25px;
}

.btn-link{
    color: #fff;
}

.titulo-proyecto{
    color: rgb(111, 162, 255);
    text-decoration: none;
}

.titulo-proyecto:hover{
    color: rgb(87, 145, 252);
}

.activeChat{
    background-color: #d8d4d4 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/Blogs/Blogs.vue